import { TimeOffType } from '@core/models/time-off/time-off-type';
import {
    IListState,
    initialListState
} from '../shared/list/list.state';
import { CreateLeavePolicyRequest } from '@core/models/leave/create-leave-policy-request';

export interface ISettingsState {
    settings: string;
    suggestions: IListState;
    leavePolicies: IListState;
    viewedLeavePolicyId: string;
    newLeavePolicy: CreateLeavePolicyRequest;
    isFetching: boolean;
    timeoffTypes: TimeOffType[];
}

export function initialSettingsState(): ISettingsState {
    return {
        settings: null,
        suggestions: {
            ...initialListState, sortBy: null
        },
        leavePolicies: {
            ...initialListState, sortBy: null
        },
        viewedLeavePolicyId: null,
        newLeavePolicy: null,
        isFetching: false,
        timeoffTypes: null
    };
}
